import { AuthDomainError } from '@/auth';

export class AmendBookingError extends AuthDomainError {}
